import $ from 'jquery';

const $fixedHeightVideos = $('.js-fixed-height-video');

$(window).resize(checkVideoHeight);
$(window).load(checkVideoHeight);

function checkVideoHeight() {
  $fixedHeightVideos.each((i, e) => {
    const $this = $(e);

    const $fixedHeightElem = $this.find('.js-fixed-height-value');
    const fixedHeightValue = $fixedHeightElem.val();

    if (window.innerWidth < (fixedHeightValue * 2)) {
      $this.removeClass('fixed-height-video');
    } else {
      $this.addClass('fixed-height-video');
    }
  });
}
